<template>
    <li class="main-nav__submenu-item">
        <a class="main-nav__submenu-link" :href="item.url">
            <span class="main-nav__submenu-link-text">{{ item.title }}</span>
        </a>
    </li>
</template>

<script>

export default {
    name: 'DesktopMenuitemChild',
    data() {
        return {
            item: [],
        };
    },
    props: ['child'],
    mounted: function() {
        this.item = this.child;
    },
};
</script>